var style = "\n<style>\n#gn-wrapper {\n  position: fixed;\n  width: 0;\n  height: 100%;\n  z-index: 100;\n  top: 0;\n  background-color: white;\n  display: block;\n  color: black;\n  max-width: 800px;\n  right: 0;\n  box-shadow: none;\n  -moz-transition: width .5s;\n  -ms-transition: width .5s;\n  -o-transition: width .5s;\n  -webkit-transition: width .5s;\n  transition: width .5s;\n  overflow: auto;\n}\n\n#gn-note {\n  padding: 10px;\n}\n\n#gn-noteEditorWrapper {\n  display: none;\n}\n\n#gn-editBtn #gn-closeBtn #gn-saveBtn {\n  display: none;\n}\n\n.gn-buttonBar {\n  position: fixed;\n  right: 15px;\n  bottom: 15px;\n  z-index: 101;\n}\n\n#gn-openBtn {\n  position: fixed;\n  right: -41px;\n  bottom: 0px;\n  transform-origin: 0 0;\n  width: 65px;\n  transform: rotate(270deg);\n  background-color: #eeeeee;\n  padding: 4px 10px;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color .3s;\n  box-sizing: border-box;\n  border: 1px solid #DDD;\n  font-size: 14px;\n  text-align: center;\n  font-family: Arial;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, .6);\n  color: black;\n}\n\n#gn-openBtn:hover {\n  background-color: #dddddd;\n}\n\n.gn-btn {\n  box-sizing: border-box;\n  position: relative;\n\n  display: inline-block;\n  padding: 0;\n\n  overflow: hidden;\n\n  border-width: 0;\n  outline: none;\n  border-radius: 2px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, .6);\n  \n  background-color: #EEEEEE;\n  color: black;\n  cursor: pointer;\n\n  transition: background-color .3s;\n}\n\n.gn-btn:hover, .gn-btn:focus {\n  background-color: #DDDDDD;\n}\n\n.gn-btn > * {\n  position: relative;\n}\n\n.gn-btn span {\n  display: block;\n  padding: 8px 16px;\n}\n\n.gn-btn:before {\n  content: \"\";\n  \n  position: absolute;\n  top: 50%;\n  left: 50%;\n  \n  display: block;\n  width: 0;\n  padding-top: 0;\n    \n  border-radius: 100%;\n  \n  background-color: rgba(236, 240, 241, .3);\n  \n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n\n.gn-btn:active:before {\n  width: 120%;\n  padding-top: 120%;\n  transition: width .2s ease-out, padding-top .2s ease-out;\n}\n\n.gn-close {\n  position: absolute;\n  right: 32px;\n  top: 32px;\n  width: 32px;\n  height: 32px;\n  opacity: 0.3;\n  cursor: pointer;\n}\n.gn-close:hover {\n  opacity: 1;\n}\n.gn-close:before, .gn-close:after {\n  position: absolute;\n  left: 15px;\n  content: ' ';\n  height: 33px;\n  width: 2px;\n  background-color: #333;\n}\n.gn-close:before {\n  transform: rotate(45deg);\n}\n.gn-close:after {\n  transform: rotate(-45deg);\n}\n\n</style>\n";
var template = "\n<link rel=\"stylesheet\" href=\"https://unpkg.com/easymde/dist/easymde.min.css\">\n".concat(style, "\n<div id=\"gn-wrapper\">\n  <div id=\"gn-closeX\" class=\"gn-close\"></div>\n  <div id=\"gn-noteWrapper\">\n    <div id=\"gn-note\"></div>\n    <div id=\"gn-noteEditorWrapper\">\n      <div><textarea id=\"gn-noteEditor\"></textarea></div>\n    </div>\n  </div>\n</div>\n<div id=\"gn-openBtn\" title=\"Show Note\">\n  Notes\n</div>\n<div class=\"gn-buttonBar\">\n  <button class=\"gn-btn\" id=\"gn-cancelBtn\"><span>Cancel</span></button>\n  <button class=\"gn-btn\" id=\"gn-editBtn\"><span>Edit</span></button>\n  <button class=\"gn-btn\" id=\"gn-closeBtn\"><span>Close</span></button>\n  <button class=\"gn-btn\" id=\"gn-saveBtn\"><span>Save</span></button>\n</div>\n");
window.module = {};
var GitNotes = /** @class */ (function () {
    function GitNotes() {
        this.hostname = '';
        this.projectId = '';
        this.branch = '';
        this.filePath = null;
        this.hasNote = false;
        this.noteContent = '';
        this.easyMde = null;
        this.showOpenButton = true;
        this.isOpen = false;
        this.el = {
            cancelBtn: null,
            closeBtn: null,
            editBtn: null,
            note: null,
            noteEditor: null,
            noteEditorWrapper: null,
            noteWrapper: null,
            openBtn: null,
            saveBtn: null,
            wrapper: null,
            closeX: null,
        };
        this.md = null;
    }
    GitNotes.prototype.init = function (_a) {
        var projectId = _a.projectId, branch = _a.branch, hostname = _a.hostname, _b = _a.showOpenButton, showOpenButton = _b === void 0 ? true : _b;
        this.hostname = hostname;
        this.projectId = projectId;
        this.branch = branch || 'main';
        this.showOpenButton = showOpenButton;
        this.createElements();
    };
    GitNotes.prototype.loadScript = function (url) {
        var scriptEl = document.createElement('script');
        scriptEl.src = url;
        document.head.append(scriptEl);
    };
    GitNotes.prototype.createElements = function () {
        var _this = this;
        this.loadScript('https://unpkg.com/easymde/dist/easymde.min.js');
        this.loadScript('https://cdnjs.cloudflare.com/ajax/libs/markdown-it/13.0.1/markdown-it.min.js');
        this.loadScript('https://cdn.jsdelivr.net/npm/markdown-it-video@0.6.3/index.min.js');
        var initMarkdownIt = function () {
            if (!window.markdownit || !window.module.exports) {
                // wait for libraries to load, they are async
                setTimeout(function () {
                    initMarkdownIt();
                }, 500);
                return;
            }
            _this.md = window.markdownit();
            // markdown-it video hack
            window.module.exports(_this.md);
        };
        initMarkdownIt();
        var mainElement = document.createElement('div');
        mainElement.innerHTML = template;
        document.body.append(mainElement);
        Object.keys(this.el).forEach(function (key) {
            _this.el[key] = document.getElementById('gn-' + key);
        });
        this.el.editBtn.addEventListener('click', function () { return _this.editNote(); });
        this.el.openBtn.addEventListener('click', function () { return _this.showNote(); });
        this.el.closeBtn.addEventListener('click', function () { return _this.hideNote(); });
        this.el.saveBtn.addEventListener('click', function () { return _this.saveNote(); });
        this.el.cancelBtn.addEventListener('click', function () { return _this.cancelNote(); });
        this.el.closeX.addEventListener('click', function () { return _this.hideNote(); });
        this.showButtons('open');
    };
    GitNotes.prototype.hideButtons = function () {
        this.el.closeBtn.style.display = 'none';
        this.el.openBtn.style.display = 'none';
        this.el.editBtn.style.display = 'none';
        this.el.saveBtn.style.display = 'none';
        this.el.cancelBtn.style.display = 'none';
    };
    GitNotes.prototype.showButtons = function (buttons) {
        var _this = this;
        this.hideButtons();
        if (!Array.isArray(buttons)) {
            buttons = [buttons];
        }
        buttons.forEach(function (b) {
            if (b === 'open' && !_this.showOpenButton) {
                return;
            }
            _this.el[b + 'Btn'].style = 'block';
        });
    };
    GitNotes.prototype.cancelNote = function () {
        this.hideEditor();
        this.showButtons(['edit', 'close']);
    };
    GitNotes.prototype.editNote = function () {
        var _this = this;
        if (!this.easyMde) {
            this.easyMde = new window.EasyMDE({
                element: document.getElementById('gn-noteEditor'),
                previewRender: function (content) { return _this.md.render(content); }, // use markdown it for previews
            });
        }
        this.el.noteEditorWrapper.style.display = 'block';
        this.el.note.style.display = 'none';
        this.el.closeX.style.display = 'none';
        this.showButtons(['cancel', 'save']);
        this.easyMde.value(this.noteContent);
    };
    GitNotes.prototype.hideEditor = function () {
        this.el.noteEditorWrapper.style.display = 'none';
        this.el.note.style.display = 'block';
        this.el.closeX.style.display = 'block';
    };
    GitNotes.prototype.hideNote = function () {
        var _this = this;
        setTimeout(function () {
            _this.el.wrapper.style.boxShadow = 'none';
        }, 500);
        this.el.wrapper.style.width = '0';
        this.showButtons('open');
        this.isOpen = false;
    };
    GitNotes.prototype.saveNote = function () {
        this.noteContent = this.easyMde.value();
        this.el.note.innerHTML = this.md.render(this.noteContent);
        if (this.hasNote) {
            this.updateNote(this.noteContent);
        }
        else {
            this.createNote(this.noteContent);
        }
        this.hideEditor();
        this.showButtons(['edit', 'close']);
    };
    GitNotes.prototype.showNote = function () {
        var _this = this;
        this.getNote()
            .then(function (r) { return r.json(); })
            .then(function (_a) {
            var content = _a.content, exists = _a.exists;
            _this.hasNote = exists;
            _this.noteContent = content || 'NO.DATA';
            _this.el.note.innerHTML = _this.md.render(_this.noteContent);
        });
        this.el.wrapper.style.boxShadow = 'rgb(0 0 0 / 50%) -2px 0px 10px 5px';
        this.el.wrapper.style.width = '100%';
        this.showButtons(['edit', 'close']);
        this.isOpen = true;
    };
    GitNotes.prototype.toggleNote = function () {
        if (this.isOpen) {
            this.hideNote();
        }
        else {
            this.showNote();
        }
    };
    GitNotes.prototype.getFilepath = function () {
        var filePath = window.location.pathname;
        if (this.filePath) {
            if (typeof this.filePath === 'function') {
                filePath = this.filePath();
            }
            if (typeof this.filePath === 'string') {
                filePath = this.filePath;
            }
        }
        if (filePath.endsWith('.md')) {
            return filePath;
        }
        // add .md extension
        var parts = filePath.split('/');
        var lastPart = parts[parts.length - 1];
        lastPart = lastPart.replace(/\..*$/, '');
        lastPart += '.md';
        parts[parts.length - 1] = lastPart;
        return parts.join('/');
    };
    GitNotes.prototype.getNote = function (filePath) {
        var _this = this;
        if (!filePath) {
            filePath = this.getFilepath();
        }
        var queryParams = ['projectId', 'branch'].map(function (x) { return "".concat(x, "=").concat(encodeURIComponent(_this[x])); });
        queryParams.push("filePath=".concat(encodeURIComponent(filePath)));
        return fetch("".concat(this.hostname, "/note?").concat(queryParams.join('&')), {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    };
    GitNotes.prototype.createNote = function (content) {
        var filePath = this.getFilepath();
        return fetch("".concat(this.hostname, "/note"), {
            method: 'POST',
            body: JSON.stringify({
                filePath: filePath,
                content: content,
                projectId: this.projectId,
                branch: this.branch,
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
    };
    GitNotes.prototype.updateNote = function (content) {
        var filePath = this.getFilepath();
        return fetch("".concat(this.hostname, "/note"), {
            method: 'PUT',
            body: JSON.stringify({
                filePath: filePath,
                content: content,
                projectId: this.projectId,
                branch: this.branch,
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
    };
    return GitNotes;
}());
window.GitNotes = new GitNotes();
//# sourceMappingURL=index.js.map